/**
 * App config: build-time Vite env + optional runtime /config.json overlay.
 * Runtime overlay is used by yarn dev:mobile so tunnel URLs do not require a rebuild.
 */

const state = {
  VITE_API_URL: undefined,
  VITE_SITE_URL: undefined,
  VITE_MEDIA_URL_DOMAIN: undefined,
  VITE_STATIC_URL_DOMAIN: undefined,
  VITE_ADMIN_DOMAIN: undefined,
  // Legacy / non-prefixed fallbacks
  MEDIA_URL_DOMAIN: undefined,
  STATIC_URL_DOMAIN: undefined,
  ADMIN_DOMAIN: undefined,
  API_URL: undefined,
  SITE_URL: undefined,
}

const KEY_ALIASES = {
  API_URL: [`API_URL`, `VITE_API_URL`, `GATSBY_API_URL`],
  SITE_URL: [`SITE_URL`, `VITE_SITE_URL`, `GATSBY_SITE_URL`],
  MEDIA_URL_DOMAIN: [`MEDIA_URL_DOMAIN`, `VITE_MEDIA_URL_DOMAIN`, `GATSBY_MEDIA_URL_DOMAIN`],
  STATIC_URL_DOMAIN: [`STATIC_URL_DOMAIN`, `VITE_STATIC_URL_DOMAIN`, `GATSBY_STATIC_URL_DOMAIN`],
  ADMIN_DOMAIN: [`ADMIN_DOMAIN`, `VITE_ADMIN_DOMAIN`, `GATSBY_ADMIN_DOMAIN`],
}

export function applyEnv(env = {}) {
  Object.keys(env).forEach(key => {
    if (env[key] != null && env[key] !== ``) {
      state[key] = env[key]
    }
  })
}

/** Merge process.env (Jest / Node) into state once. */
export function applyProcessEnv() {
  if (typeof process === `undefined` || !process.env) {
    return
  }
  applyEnv(process.env)
}

let processApplied = false

export function getConfig(name) {
  if (!processApplied) {
    applyProcessEnv()
    processApplied = true
  }
  const aliases = KEY_ALIASES[name] || [name]
  for (let i = 0; i < aliases.length; i++) {
    const key = aliases[i]
    if (state[key] != null && state[key] !== ``) {
      return state[key]
    }
  }
  return undefined
}

/**
 * Fetch /config.json (written by dev:mobile). Missing file is fine in production.
 */
export async function loadRuntimeConfig() {
  try {
    const res = await fetch(`/config.json`, { cache: `no-store` })
    if (!res.ok) {
      return
    }
    const data = await res.json()
    applyEnv(data)
  } catch (e) {
    // no runtime config — use build-time env only
  }
}
